import ExcelJS from "exceljs";

async function handleTableExport(columns, entries, objectName) {
    const workbook = new ExcelJS.Workbook();
    workbook.creator = "OpenTreasury";
    let sheet = workbook.addWorksheet(`export_${objectName}`);

    sheet.addRow(columns.map(col => col.caption))

    let rowsFromForms = entries.map(resultEntry => {
        let row = [];
        row.push(...columns.map(col => (col.exportDatum || col.datum)(resultEntry)));
        return row;
    });
    sheet.addRows(rowsFromForms);

    sheet.getRow(1).font = {bold: true, color: {argb: "FFFFFFFF"}}
    sheet.getRow(1).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {argb: '006EBBFF'},
    }

    // sheet.autoFilter = "A1:J1"
    try {
        let xls64 = await workbook.xlsx.writeBuffer({
            base64: true
        })


        let a = document.createElement("a");
        let data = new Blob([xls64], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});

        let url = URL.createObjectURL(data);
        a.href = url;
        a.download = `export_${objectName}.xlsx`;
        document.body.appendChild(a);
        a.click();
        setTimeout(function () {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            },
            0);
    } catch (error) {

    }
}

const OT_SPECIAL_BG_COLOR = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: {argb: 'FFc84a4b'},
}

const OT_BG_COLOR = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: {argb: 'FF676864'},
}


const BORDER = {
    top: {style: 'thin'},
    left: {style: 'thin'},
    bottom: {style: 'thin'},
    right: {style: 'thin'}
}

const WHITE_BOLD_TEXT = {bold: true, color: {argb: "FFFFFFFF"}};


const excelExport = async function (columnsMatrix, exportedData, config) {

    const highlightColumnIndexes = [];

    const addHeaderRowsToSheet = () => {
        for (const [rowIndex, columns] of Object.entries(columnsMatrix)) {

            const rowNumber = Number(rowIndex) + 1;
            let startColumnNumber = 1;

            for (const column of columns) {

                const columnSpan = column.count - 1;
                const rowSpan = column.rowCount ? column.rowCount - 1 : 0;

                const mergedCell = columnSpan || rowSpan;

                if (mergedCell) {
                    const mergeColumnFrom = startColumnNumber;
                    const mergeColumnTo = startColumnNumber + columnSpan;
                    const mergeRowFrom = rowNumber - rowSpan;
                    const mergeRowTo = rowNumber;
                    workSheet.mergeCells(mergeRowFrom, mergeColumnFrom, mergeRowTo, mergeColumnTo);
                }


                const row = workSheet.getRow(rowNumber);
                const cell = row.getCell(startColumnNumber);


                if (mergedCell) {

                    cell.alignment = {horizontal: 'center'};
                }


                if (column.name.includes('Datum')) {
                    console.log(column.name)
                    console.log('ROW', rowSpan, columnsMatrix.length - 1)

                }


                cell.border = BORDER;
                cell.font = WHITE_BOLD_TEXT;
                cell.value = column.name;


                if (column.highlight) {
                    highlightColumnIndexes.push(startColumnNumber - 1);
                } else {
                    cell.fill = OT_BG_COLOR;
                }


                startColumnNumber += columnSpan + 1;
            }
        }

    }

    const addDataToSheet = () => {
        const NUMBER_FORMAT = '0.' + '0'.repeat(config.decimalPLaces)

        for (const exportedRow of exportedData) {
            const row = workSheet.addRow(exportedRow)
            for (let colIndex = 1; colIndex < exportedRow.length - 1; colIndex++) {
                row.getCell(colIndex).numFmt = NUMBER_FORMAT;
            }
        }
    }

    const setWidthOfColumns = () => {

        for (const column of workSheet.columns) {
            let dataMax = 0;

            column.eachCell({includeEmpty: true}, function (cell) {
                let columnLength = cell.value?.length ? cell.value.length : 0;
                if (columnLength > dataMax) {
                    dataMax = columnLength;
                }
            });

            column.width = dataMax < 10 ? 10 : dataMax + 2;
        }

    }

    const styleWorkSheet = () => {

        for (const [index, column] of Object.entries(workSheet.columns)) {
            if (highlightColumnIndexes.includes(+index)) {
                column.eachCell(cell => {
                    cell.fill = OT_SPECIAL_BG_COLOR
                })
            }
        }
    }


    const workbook = new ExcelJS.Workbook();
    workbook.creator = "OpenTreasury";
    let workSheet = workbook.addWorksheet(config.sheetName);

    addHeaderRowsToSheet();

    addDataToSheet();

    setWidthOfColumns();

    styleWorkSheet()


    try {
        let xls64 = await workbook.xlsx.writeBuffer({
            base64: true
        })


        let a = document.createElement("a");
        let data = new Blob([xls64], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});

        let url = URL.createObjectURL(data);
        a.href = url;
        a.download = `export_${config.tableName}.xlsx`;
        document.body.appendChild(a);
        a.click();
        setTimeout(function () {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            },
            0);
    } catch (error) {
        console.log('ERRRRRROR');
        console.warn(error)
    }
}


export default handleTableExport

export { excelExport };